import React from 'react'
import StudentsList from '../../components/admin/StudentsList'

export default function StudentList() {
  return (
    < >
        <StudentsList/>
    </>
  )
}
